/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useCallback, useEffect } from 'react'
import { createPortal } from 'react-dom'

import s from './EditCollection.module.css'
import { FileInput } from '../FileInput'
import { Select } from '../CreatableSelect'

export function EditCollection({ onClose, id }) {
  const [inProgress, setInProgress] = useState(false)
  const [collectionName, setCollectionName] = useState('')
  const [collectionNote, setCollectionNote] = useState('')
  const [email, setEmail] = useState([])
  const [phone, setPhone] = useState([])
  const [fileImageUrl, setFileImageUrl] = useState('')
  const [fileImage, setFileImage] = useState('')

  useEffect(() => {
    async function getCollectionDetails() {
      try {
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${id} `, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })

        const data = await response.json()

        if (data.name) {
          setCollectionName(data.name)
        }

        if (data.description) {
          setCollectionNote(data.description)
        }

        if (data.cover_photo_url) {
          setFileImageUrl(data.cover_photo_url)
        }

        if (data.shared_with_contacts) {
          const emails = data.shared_with_contacts.filter((item) => item.type === 'email')
          const phones = data.shared_with_contacts.filter((item) => item.type === 'phone')

          if (emails.length > 0) {
            setEmail(emails.map((item) => item.value))
          }

          if (phones.length > 0) {
            setPhone(phones.map((item) => item.value))
          }
        }

        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }

    getCollectionDetails()
  }, [id])

  const handleUpdateCollection = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const formData = new FormData()

      formData.append('document_type', 'proof_of_payment')

      formData.append('listing_collection[name]', collectionName)
      formData.append('listing_collection[description]', collectionNote)
      formData.append('listing_collection[cover_photo]', fileImage)

      const sharedContacts = [
        ...email.map((emailItem) => ({
          value: emailItem,
          type: 'email',
        })),
        ...phone.map((phoneItem) => ({
          value: phoneItem,
          type: 'phone',
        })),
      ]

      sharedContacts.forEach((contactItem, index) => {
        formData.append(`listing_collection[shared_with_contacts][${index}][type]`, contactItem.type)
        formData.append(`listing_collection[shared_with_contacts][${index}][value]`, contactItem.value)
      })

      const response = await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          API_TOKEN: apiToken,
        },
        method: 'PUT',
        body: formData,
      })

      const data = await response.json()
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
      onClose()
    }
  }, [collectionName, collectionNote, onClose, email, phone, fileImage])

  const handleDelete = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      onClose()
    }
  }, [id, onClose])

  const handleChangeEmail = (selectedValues) => {
    setEmail(selectedValues)
  }

  const handleChangePhone = (selectedValues) => {
    setPhone(selectedValues)
  }

  return createPortal(
    <div className={s.root}>
      <FileInput initialFileUrl={fileImageUrl} onFileChange={(file) => setFileImage(file)} accept="image/*" />

      <label className={s.label} htmlFor="name">
        Collection Name
      </label>
      <input
        className={s.input}
        type="text"
        id="name"
        value={collectionName}
        autoComplete="off"
        onChange={(e) => {
          const { value } = e.target
          setCollectionName(value)
        }}
      />

      <label className={s.label} htmlFor="email">
        Email
      </label>
      <Select options={email} initialValues={email} onChange={handleChangeEmail} />

      <label className={s.label} htmlFor="tel">
        Phone
      </label>
      <Select options={phone} initialValues={phone} onChange={handleChangePhone} />

      <label className={s.label} htmlFor="note">
        Notes <span className={s.optional}>(optional)</span>
      </label>
      <textarea
        name="note"
        className={s.textarea}
        rows={4}
        value={collectionNote}
        onChange={(e) => {
          const { value } = e.target
          setCollectionNote(value)
        }}
      />

      <div className={s.controls}>
        <button type="button" className={s.update} disabled={inProgress} onClick={handleUpdateCollection}>
          {inProgress ? 'Loading...' : 'Update'}
        </button>

        <button type="button" className={s.close} onClick={onClose}>
          Close
        </button>

        <button type="button" className={s.delete} onClick={handleDelete}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_7006_1751)">
              <path
                d="M20.25 5.625H3.75"
                stroke="#EC6F6F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.75 9.75V15.75"
                stroke="#EC6F6F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.25 9.75V15.75"
                stroke="#EC6F6F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.75 5.625V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.625"
                stroke="#EC6F6F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.75 5.625V3.375C15.75 2.97718 15.592 2.59564 15.3107 2.31434C15.0294 2.03304 14.6478 1.875 14.25 1.875H9.75C9.35218 1.875 8.97064 2.03304 8.68934 2.31434C8.40804 2.59564 8.25 2.97718 8.25 3.375V5.625"
                stroke="#EC6F6F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_7006_1751">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Delete Collection
        </button>
      </div>

      <svg
        className={s.closeIcon}
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        onClick={() => onClose()}
      >
        <path
          d="M22.4946 21.2564C22.5758 21.3377 22.6403 21.4342 22.6843 21.5405C22.7283 21.6467 22.751 21.7605 22.751 21.8755C22.751 21.9905 22.7283 22.1043 22.6843 22.2105C22.6403 22.3167 22.5758 22.4133 22.4946 22.4946C22.4133 22.5758 22.3167 22.6403 22.2105 22.6843C22.1043 22.7283 21.9905 22.751 21.8755 22.751C21.7605 22.751 21.6467 22.7283 21.5405 22.6843C21.4342 22.6403 21.3377 22.5758 21.2564 22.4946L14.0005 15.2375L6.74455 22.4946C6.58036 22.6587 6.35768 22.751 6.12549 22.751C5.89329 22.751 5.67061 22.6587 5.50642 22.4946C5.34224 22.3304 5.25 22.1077 5.25 21.8755C5.25 21.6433 5.34224 21.4206 5.50642 21.2564L12.7635 14.0005L5.50642 6.74455C5.34224 6.58036 5.25 6.35768 5.25 6.12549C5.25 5.89329 5.34224 5.67061 5.50642 5.50642C5.67061 5.34224 5.89329 5.25 6.12549 5.25C6.35768 5.25 6.58036 5.34224 6.74455 5.50642L14.0005 12.7635L21.2564 5.50642C21.4206 5.34224 21.6433 5.25 21.8755 5.25C22.1077 5.25 22.3304 5.34224 22.4946 5.50642C22.6587 5.67061 22.751 5.89329 22.751 6.12549C22.751 6.35768 22.6587 6.58036 22.4946 6.74455L15.2375 14.0005L22.4946 21.2564Z"
          fill="currentColor"
        />
      </svg>
    </div>,
    document.body
  )
}
